import React, { createContext, useContext, useState, useCallback } from 'react';

interface TopBarActionsContextData {
  actions: React.ReactNode;
  setActions: (node: React.ReactNode) => void;
}

const TopBarActionsContext = createContext<TopBarActionsContextData>({
  actions: null,
  setActions: () => {},
});

export const TopBarActionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [actions, setActionsState] = useState<React.ReactNode>(null);

  const setActions = useCallback((node: React.ReactNode) => {
    setActionsState(node);
  }, []);

  return (
    <TopBarActionsContext.Provider value={{ actions, setActions }}>
      {children}
    </TopBarActionsContext.Provider>
  );
};

export function useTopBarActions(): TopBarActionsContextData {
  return useContext(TopBarActionsContext);
}
